import { render, staticRenderFns } from "./commodityStocks.vue?vue&type=template&id=501b5668&"
import script from "./commodityStocks.vue?vue&type=script&lang=js&"
export * from "./commodityStocks.vue?vue&type=script&lang=js&"
import style0 from "./commodityStocks.vue?vue&type=style&index=0&id=501b5668&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports